'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nextMoment = require('../../../next-moment/lib/index.js');

var _nextMoment2 = _interopRequireDefault(_nextMoment);

var _validators = require('../utils/validators.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CalendarProps = {
    propTypes: {
        prefix: _propTypes2['default'].string,
        base: _propTypes2['default'].any,
        value: _propTypes2['default'].any,
        mode: _propTypes2['default'].oneOf(['month', 'year', 'decade']),
        dateCellRender: _propTypes2['default'].func,
        monthCellRender: _propTypes2['default'].func,
        yearCellRender: _propTypes2['default'].func,
        disabledDate: _propTypes2['default'].func,
        disabledMonth: _propTypes2['default'].func,
        disabledYear: _propTypes2['default'].func,
        language: _propTypes2['default'].oneOf(['en-us', 'ar', 'de', 'es', 'fr', 'hi', 'it', 'ja', 'ko', 'pt', 'ru', 'zh-cn', 'zh-hk', 'zh-tw']),
        locale: _propTypes2['default'].object
    },

    defaultProps: {
        prefix: 'next-'
    }
};

var CalendarMixin = {
    isAllowedDate: function isAllowedDate(value) {
        var disabledDate = this.props.disabledDate;


        if (disabledDate && typeof disabledDate === 'function' && disabledDate(value)) {
            return false;
        }

        return true;
    },
    isAllowedMonth: function isAllowedMonth(value) {
        var disabledMonth = this.props.disabledMonth;


        if (disabledMonth && typeof disabledMonth === 'function' && disabledMonth(value)) {
            return false;
        }

        return true;
    },
    isAllowedYear: function isAllowedYear(value) {
        var disabledYear = this.props.disabledYear;


        if (disabledYear && typeof disabledYear === 'function' && disabledYear(value)) {
            return false;
        }

        return true;
    },
    isSameDay: function isSameDay(one, two) {
        if (!one || !two) {
            return false;
        }

        one = (0, _nextMoment2['default'])(one).format('YYYY-MM-DD');
        two = (0, _nextMoment2['default'])(two).format('YYYY-MM-DD');

        return (0, _nextMoment2['default'])(one).isSame(two);
    },
    isRangeDay: function isRangeDay(day, range) {
        if (!day || !range[0] || !range[1]) {
            return false;
        }

        var theDay = (0, _nextMoment2['default'])(day).format('YYYY-MM-DD'),
            rangeOne = (0, _nextMoment2['default'])(range[0]).format('YYYY-MM-DD'),
            rangeTwo = (0, _nextMoment2['default'])(range[1]).format('YYYY-MM-DD');

        return (0, _nextMoment2['default'])(theDay).isBetween(rangeOne, rangeTwo);
    },
    getMonthsLocale: function getMonthsLocale(language) {
        // 设置多语言
        _nextMoment2['default'].locale(language);

        var localeData = _nextMoment2['default'].localeData(),
            monthsLocale = void 0;

        // 获得多语言月份
        try {
            monthsLocale = localeData.monthsShort();
        } catch (e) {
            monthsLocale = localeData.months();
        }

        return monthsLocale instanceof Array ? monthsLocale : monthsLocale.format;
    },
    getDecadeYears: function getDecadeYears(baseYear) {
        var base = Math.floor(baseYear / 10),
            years = [];

        for (var i = 0; i < 10; i++) {
            years.push(base * 10 + i);
        }

        return years;
    },
    getLateastYears: function getLateastYears(baseYear) {
        var years = [];

        for (var i = 0; i < 21; i++) {
            years.push(baseYear - 10 + i);
        }

        return years;
    },
    getCalendar: function getCalendar(base, language, locale) {
        // 设置多语言
        _nextMoment2['default'].locale(language);
        var localeData = _nextMoment2['default'].localeData();
        var firstDayOfWeek = localeData.firstDayOfWeek();

        var _ref = locale.format || {},
            customFirstDayOfWeek = _ref.firstDayOfWeek;

        if ((0, _validators.isWeekdayIndex)(customFirstDayOfWeek)) {
            firstDayOfWeek = customFirstDayOfWeek;
        }

        var calendarStartWeek = [7, 1, 2, 3, 4, 5, 6][firstDayOfWeek]; // firstDayOfWeek 0为周日

        // 基准日期
        var baseDay = (0, _nextMoment2['default'])(base) || (0, _nextMoment2['default'])(),
            baseDayYear = baseDay.year(),
            baseDayMonth = baseDay.month(),
            baseMonthDays = baseDay.daysInMonth();

        // 第一天
        var firstDayWeek = baseDay.startOf('month').isoWeekday();

        // 最后一天
        var lastDayWeek = baseDay.endOf('month').isoWeekday();

        // 上个月
        var prevMonth = baseDayMonth - 1 < 0 ? 11 : baseDayMonth - 1;
        var prevMonthDays = baseDay.month(prevMonth).daysInMonth();
        var prevYear = prevMonth === 11 ? baseDayYear - 1 : baseDayYear;
        var calendarPrevMonthDays = (firstDayWeek - calendarStartWeek + 14) % 7; //上月calendar剩余天数

        // 下个月
        var nextMonth = baseDayMonth + 1 > 11 ? 0 : baseDayMonth + 1;
        var nextYear = nextMonth === 0 ? baseDayYear + 1 : baseDayYear;
        var calendarNextMonthDays = (calendarStartWeek - lastDayWeek + 13) % 7; //下月calendar剩余天数

        // 日历
        var totalDays = baseMonthDays + calendarPrevMonthDays + calendarNextMonthDays,
            counter = totalDays,
            calendarWeek = [],
            calendar = [];

        // 根据基准日期获得日历

        var _loop = function _loop(i) {
            var date = void 0,
                year = void 0,
                month = void 0,
                prevDay = void 0,
                curDay = void 0,
                nextDay = void 0;

            prevDay = prevMonthDays - calendarPrevMonthDays + i;
            prevDay = prevDay > prevMonthDays ? 0 : prevDay;

            curDay = i - calendarPrevMonthDays;
            curDay = curDay > baseMonthDays ? 0 : curDay;

            nextDay = i - totalDays + calendarNextMonthDays;
            date = prevDay || curDay || nextDay;

            if (prevDay) {
                month = prevMonth;
                year = prevYear;
            } else if (curDay) {
                month = baseDayMonth;
                year = baseDayYear;
            } else if (nextDay) {
                month = nextMonth;
                year = nextYear;
            }

            // CalendarDate 类型
            calendarWeek.push({
                value: {
                    timestamp: (0, _nextMoment2['default'])().year(year).month(month).date(date).valueOf(),
                    year: year,
                    month: month, // 0~11
                    date: date, // 1~31
                    week: (calendarStartWeek + i - 1) % 7 === 0 ? 7 : (calendarStartWeek + i - 1) % 7, // 1 ~ 7
                    valueOf: function valueOf() {
                        return (0, _nextMoment2['default'])().year(year).month(month).date(date).valueOf();
                    }
                },
                base: {
                    timestamp: baseDay.valueOf(),
                    year: baseDay.year(),
                    month: baseDayMonth, // 0~11
                    date: baseDay.date(), // 1~31
                    week: baseDay.isoWeekday(), // 1~7
                    valueOf: function valueOf() {
                        return baseDay.valueOf();
                    }
                }
            });

            if (calendarWeek.length === 7) {
                calendar.push(calendarWeek);
                calendarWeek = [];
            }
        };

        for (var i = 1; i <= counter; i++) {
            _loop(i);
        }

        return calendar;
    }
};

function extend(a, b) {
    for (var key in b) {
        if (b.hasOwnProperty(key)) {
            a[key] = b[key];
        }
    }
}

function CalendarMixinTo(Component) {
    ['defaultProps', 'propTypes'].forEach(function (prop) {
        Component[prop] = Component[prop] || {};
        extend(Component[prop], CalendarProps[prop]);
    });

    extend(Component.prototype, CalendarMixin);
}

exports['default'] = CalendarMixinTo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-calendar/lib/view/calendar-mixin.js
// module id = 43
// module chunks = 0